export type EditorRoute = {
  projectId: string;
  elementId?: string;
  productId?: string;
};

export const routes = {
  signup: "/auth/signup",
  home: {
    root: "/home",
    shareTemplate: "/home/template/:templateId",
  },
  allProjects: "/shops/all",
  editor: {
    project: "/editor/:projectId",
    element: "/editor/:projectId/:elementId",
    settings: "/editor/:projectId/project-settings",
    integrations: "/editor/:projectId/integrations",
  },
  workspace: {
    projects: "/workspace/:workspaceId/projects",
    integrations: {
      list: "/workspace/:workspaceId/integrations",
      shopify: "/workspace/:workspaceId/integrations/shopify",
    },
    billing: "/workspace/:workspaceId/billing",
    experiments: {
      list: "/workspace/:workspaceId/abtesting",
      settings: "/workspace/:workspaceId/abtesting/settings",
      details: "/workspace/:workspaceId/abtesting/:experimentId/details",
      results: "/workspace/:workspaceId/abtesting/:experimentId/results",
      edit: "/workspace/:workspaceId/abtesting/:experimentId/edit",
    },
    members: "/workspace/:workspaceId/members",
    settings: {
      general: "/workspace/:workspaceId/settings/general",
      members: "/workspace/:workspaceId/settings/members",
      billing: "/workspace/:workspaceId/settings/billing",
      affiliates: "/workspace/:workspaceId/settings/affiliates",
    },
  },
  analytics: {
    overview: "/workspace/:workspaceId/analytics/overview",
    pageDetails: "/workspace/:workspaceId/analytics/deep-dive",
    insights: "/workspace/:workspaceId/analytics/insights",
    home: "/workspace/:workspaceId/analytics/home",
  },

  /* NOTE (Craig, 2025-05-06): This is the new shops layout routes. */
  shops: {
    all: "/shops/all",
    root: "/shops/:projectId",
    site: "/shops/:projectId/site",
    analytics: {
      overview: "/shops/:projectId/analytics/overview",
      pageDetails: "/shops/:projectId/analytics/deep-dive",
      insights: "/shops/:projectId/analytics/insights",
      home: "/shops/:projectId/analytics/home",
    },
    settings: {
      profile: "/shops/:projectId/settings/profile",
      shops: {
        general: "/shops/:projectId/settings/shop/general",
        connections: "/shops/:projectId/settings/shop/connections",
        fonts: "/shops/:projectId/settings/shop/fonts",
        scripts: "/shops/:projectId/settings/shop/scripts",
        integrations: "/shops/:projectId/settings/shop/integrations",
        abtesting: "/shops/:projectId/settings/shop/abtesting",
      },
      workspace: {
        general: "/shops/:projectId/settings/workspace/general",
        members: "/shops/:projectId/settings/workspace/members",
        billing: "/shops/:projectId/settings/workspace/billing",
        affiliates: "/shops/:projectId/settings/workspace/affiliates",
      },
    },
    experiments: {
      list: "/shops/:projectId/abtesting",
      details: "/shops/:projectId/abtesting/:experimentId/details",
      results: "/shops/:projectId/abtesting/:experimentId/results",
      edit: "/shops/:projectId/abtesting/:experimentId/edit",
    },
    editor: {
      root: "/shops/:projectId/editor",
      element: "/shops/:projectId/editor/:elementId",
      settings: "/shops/:projectId/editor/project-settings",
      integrations: "/shops/:projectId/editor/integrations",
    },
    growthAudits: "/shops/:projectId/growth-audits",
    styleExtraction: "/shops/:projectId/style-extraction",
    designLibrary: "/shops/:projectId/design-library",
    products: {
      list: "/shops/:projectId/products",
      edit: "/shops/:projectId/products/:productId/edit",
    },
  },
};

export function addReferralToUrl(url: string, referral: string | null) {
  if (!referral) {
    return url;
  }
  return `${url}?referral=${referral}`;
}
